module.exports = __webpack_public_path__ + "media/images/plus/3-device-mashup-promo_v2-afaad872a7ef5c0ace3bbfca45b409f9.png";